var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpaceforceIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0L0 24L8 19.2074L16 24L8 0ZM1.65633 21.9923L7.37588 4.78622L5.4859 17.291L2.56851 20.8498L6.09242 17.7444L7.41588 18.5344L1.65633 21.9923ZM8 17.3759L7.61432 16.0283L6.26685 15.6405L7.61432 15.2528L8 13.9068L8.38568 15.2528L9.73315 15.6405L8.38568 16.0283L8 17.3759ZM9.90598 17.7444L13.4315 20.8498L10.5141 17.291L8.62412 4.78622L14.3453 21.9923L8.58412 18.5344L9.90598 17.7444Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceforceIconWhite);
export default __webpack_public_path__ + "static/media/spaceforce-icon-white.59ab1fc4e121d8f9155e68fe6b55b066.svg";
export { ForwardRef as ReactComponent };